import script from "./leave-report.vue?vue&type=script&setup=true&lang=js"
export * from "./leave-report.vue?vue&type=script&setup=true&lang=js"

import "./leave-report.vue?vue&type=style&index=0&id=4562bd64&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4562bd64"]])

export default __exports__